import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Masterclass enrolment for the signed-in BWGELA user: { enrolled, is_contact, learner_number, client, ... } or null.
export const useExecutiveMe = () => {
  const { token, isAuthenticated } = useAuth();
  const [me, setMe] = useState(null);
  const load = useCallback(() => {
    if (!isAuthenticated || !token) { setMe(null); return; }
    axios.get(`${BACKEND_URL}/api/executive/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMe(r.data)).catch(() => setMe(null));
  }, [token, isAuthenticated]);
  useEffect(() => { load(); }, [load]);
  return [me, load];
};
